import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const onboardingSiteSetupChecklistAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.OnboardingSiteSetupChecklist],
}

export const onboardingRetailerProfileViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.OnboardingRetailerProfileView],
}

export const onboardingRetailerProfileModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.OnboardingRetailerProfileModify],
}

export const adminStorefrontSetupViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.OnboardingAdminStorefrontSetupView],
}

export const adminStorefrontSetupModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.OnboardingAdminStorefrontSetupModify],
}

export const whitelabelSiteCustomizableStringsViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.WhitelabelSiteCustomizableStringsView],
}

export const whitelabelSiteCustomizableStringsModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.WhitelabelSiteCustomizableStringsModify],
}

export const partnerStorefrontSetupViewAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.PartnerStorefrontSetupView],
  },
  {
    permissions: [Permission.OnboardingAdminStorefrontSetupView],
  },
]

export const partnerStorefrontSetupModifyAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.PartnerStorefrontSetupModify],
  },
  {
    permissions: [Permission.OnboardingAdminStorefrontSetupModify],
  },
]

export const mobileManagementViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MobileManagementView],
}
